import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    usersArray: []
}

export const fetchUsers = createAsyncThunk(
    'users/fetchUsers',
    async (accessToken, thunkAPI) => {
        try {
            const usersPromise = await fetch(process.env.REACT_APP_DATABASE_URL + '/users', {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                mode: 'cors',
                credentials: 'include'
            });
            const users = await usersPromise.json();
            return users;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.message);
        }
    }
);

export const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        userDeleted: (state, action) => {
            const userId = action.payload;
            state.usersArray = state.usersArray.filter(user => user.id !== parseInt(userId));
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchUsers.pending, (state, action) => {
        })
        .addCase(fetchUsers.fulfilled, (state, action) => {
            const usersData = action.payload;

            if(usersData.success === true) {
                state.usersArray = usersData.list_users;
            } else if (usersData.description) {
                alert(`AuthError. Issue fetching users. Error: ${usersData.code}. Description: ${usersData.description}.`);
            } else {
                alert(`Issue fetching users. Error: ${usersData.error}. Description: ${usersData.message}.`);
            }
        })
        .addCase(fetchUsers.rejected, (state, action) => {
        })
    }
});

export const { userDeleted } = usersSlice.actions;
export default usersSlice.reducer;
